import { Heading as _Heading, FONT_SIZE, mq, COLOR, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { LINE_STYLE } from "~/styles/line-style";

export const DivNotCastWrapper = styled.div<{ hasCastData: boolean }>`
  width: ${({ hasCastData }) => (hasCastData ? "48%" : "100%")};

  ${mq.sp} {
    width: 100%;

    &:not(:first-of-type) {
      margin-top: 16px;
    }
  }
`;

export const DivWrapper = styled.div`
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Heading = styled(_Heading)`
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: ${FONT_SIZE.M}px;
  font-weight: ${FONT_WEIGHT.BOLD};
  color: ${COLOR.GRAY900.code};

  ${mq.sp} {
    font-size: ${FONT_SIZE.S}px;
  }

  &:first-of-type {
    margin-top: 0;
  }
`;

export const DivItemText = styled.div`
  font-size: ${FONT_SIZE.S}px;
  font-weight: ${FONT_WEIGHT.NORMAL};
  color: ${COLOR.GRAY900.code};
  ${LINE_STYLE(1)}
  word-break: break-all;

  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const DivLinkWrapper = styled.div`
  display: flex;
  align-items: center;

  ${mq.sp} {
    border-bottom: 1px solid ${COLOR.GRAY200.code};
  }

  a {
    width: 100%;
  }
`;

export const ParCopyRight = styled.p`
  margin-top: 16px;
  color: ${COLOR.GRAY500.code};
  font-size: ${FONT_SIZE.XS}px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.XXS}px;
  }
`;
